<template lang="pug">
  .middle-box.text-center.animated.fadeInDown
    h1 404
    h3.font-bold Page Not Found
    .error-desc Sorry, but the page you are looking for has note been found. Try checking the URL for error, then hit the refresh button on your browser or try found something else in our app.
    br
    button.btn.btn-lg.btn-primary(@click="$router.push({ name: 'Dashboard' })") Return Home

</template>

<script>
  import $ from 'jquery'

  export default {
    mounted () {
      $('body').addClass('gray-bg')
    },
    destroyed () {
      $('body').removeClass('gray-bg')
    }
  }
</script>



// WEBPACK FOOTER //
// 404.vue?5e81736f